import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateSkills } from "../../apis/skills";
import { closeSkills } from "../../store/Partner/modalSlice";
import { useDispatch } from "react-redux";

export const useUpdatePartnerSkills = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: (selectedSkills) => updateSkills(selectedSkills),
    onSuccess: async (data) => {
      // Update partner_data immediately (optional)
      queryClient.setQueryData(["partner_data"], (oldData) => ({
        ...oldData,
        ...data,
      }));

      // Invalidate the "skills" query to refetch it fresh
      await queryClient.invalidateQueries(["skills"]);

      // Close the modal
      dispatch(closeSkills());
    },
    onError: (error) => {
      console.error("Error Updating Partner Skills!", error);
    },
  });
};
